import React, { PropTypes } from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import logo from "../../assets/images/majorLogo.png";

import { getEnvironmentProperties } from "./environmentProperties";

const PublicPage = ({
  children,
  cssClass,
  clientDesignator,
  languageSwitch,
  pageExists,
}) => {
  const { displayEnvironmentOnScreen } = getEnvironmentProperties();
  const nonProdBannerClass = displayEnvironmentOnScreen ? "banner-offset" : "";

  return (
    <div className={`public-page ${nonProdBannerClass} ${cssClass}`}>
      <div className="header-wrapper">
        <div className="header">
          <div className="banner">
            <span className="logo">
              <img src={logo} width="70" />
            </span>
            <span className="title">
              <FormattedMessage id="publicPage.header.majorPlan" />
              <FormattedMessage id="publicPage.header.studentSolution" />
            </span>
            <span className="lang-switcher">
              <span>{languageSwitch}</span>
            </span>
          </div>
          {pageExists && (
            <div className="association">
              <FormattedMessage id="publicPage.header.yourAssociation" />
              <h1>{clientDesignator}</h1>
            </div>
          )}
        </div>
      </div>

      {(!pageExists && (
        <div className="content">
          <h2>
            <FormattedMessage id="publicPage.404.title" />
          </h2>
          <p>
            <FormattedMessage id="publicPage.404.text" />
          </p>
        </div>
      )) || <div className="content">{children}</div>}

      <div className="footer-wrapper">
        <div className="footer">
          <FormattedHTMLMessage id="publicPage.footer.copyrights">
            {(m) => (
              <div
                className="copyright"
                dangerouslySetInnerHTML={{ __html: m }}
              />
            )}
          </FormattedHTMLMessage>
          <div className="contact">
            <FormattedHTMLMessage id="publicPage.footer.contactEmail">
              {(m) => (
                <div
                  className="email"
                  dangerouslySetInnerHTML={{ __html: m }}
                />
              )}
            </FormattedHTMLMessage>
            <FormattedHTMLMessage id="publicPage.footer.contactPhone">
              {(m) => (
                <div
                  className="phone"
                  dangerouslySetInnerHTML={{ __html: m }}
                />
              )}
            </FormattedHTMLMessage>
          </div>
        </div>
      </div>
    </div>
  );
};

PublicPage.defaultProps = {
  cssClass: "",
  pageExists: false,
};

PublicPage.propTypes = {
  cssClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  clientDesignator: PropTypes.string,
  languageSwitch: PropTypes.node,
  pageExists: PropTypes.bool,
};

export default PublicPage;



// WEBPACK FOOTER //
// ./src/components/common/PublicPage.js